// 同步口令的内存会话存储（页面刷新后需重新输入）。
// 不写入 localStorage / 任何持久化存储；设置页与自动快照调度共用，
// 因此从 SyncSettings 的模块私有变量提升为独立服务模块。
let _sessionPassword: string | null = null;
let _sessionSalt: string | null = null;

export const getSyncSessionPassword = (): string | null => _sessionPassword;
export const setSyncSessionPassword = (password: string | null): void => {
  _sessionPassword = password || null;
};

export const getSyncSessionSalt = (): string | null => _sessionSalt;
export const setSyncSessionSalt = (salt: string | null): void => {
  _sessionSalt = salt || null;
};
